import { Component, Input, EventEmitter, Output } from '@angular/core';
import { PropertyInterface } from '@shared/models/reports/report-view.model';
import { CbreAlertService } from '@cbre/alerts';

@Component({
  selector: '[miq-card]',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false,
})
export class CardComponent {
  @Input() data: any;
  @Input() selected = false;
  @Input() config: {
    cardClass?: string;
    controlType: string;
    fields: PropertyInterface[];
    isMiqSource?: boolean;
    icon?: string;
    style?: any;
  };

  @Output() selection = new EventEmitter<any>();
  constructor(private cbreAlertService: CbreAlertService) {}

  onRadioSelect($event) {
    if ($event.value.miq_record_hide_f) {
      $event.source.checked = false;
      this.cbreAlertService.showInfoSnackBar_l10n('recordsSearch.propertyInactive', { duration: 5000 });
    } else {
      this.selection.emit({ ...$event, config: this.config });
    }
  }

  toggleChange(data, checked) {
    this.selected = checked;
    this.selection.emit({ data, checked, config: this.config });
  }
}
